import SpineSymbol from 'core/display/spines/SpineSymbol'
import Sprite from 'core/display/Sprite'
import { time } from 'settings/custom/win'
import { tint } from 'utils/Tweens'

import { signal } from '../../../../../services/SignalsService'
import { Device } from '../../../../../utils/Device'
import { create, replace } from '../../../../../utils/Object'

export default class TwoSymbols extends PIXI.Container {
  constructor(id, settings) {
    super()
    this.id = id
    this.settings = settings
    this._sprite = null
    this._fs = false
    this._scale = Device.isDesktop() ? 1 : 0.5
    this.createSymbol(id)
    this.createSignal()
  }
  createSignal() {
    signal.on('FREESPINS-MODE', (value) => this.changeFS(value))

  }
  changeFS(value){
    this._fs = value
    this.playStatic()
  }
  reset(){
    this._spine.stop()
  }

  get sprite() {
    return this._sprite
  }

  createSymbol(id) {
    this.createSprite(id)
    this.createSpine(id)
  }

  createSpine(id){
    const { win, items } = this.settings
    this._spine = new SpineSymbol(create(items, replace(win, 'spine', id)))
    this._spine.scale.set(this._scale)
    this._spine.visible  = false
    this._spine.stop()
    this.addChild(this._spine)
  }

  createSprite(id) {
    const mode = this._fs
    this._sprite = new Sprite({ texture: game.getTextureFromAtlases(id) })
    this._staticTex = game.getTextureFromAtlases(id)
    this._staticFSTex = game.getTextureFromAtlases(id + '_fs')
    this._blurTexture = game.getTextureFromAtlases(id + '_blur')
    this._blurFSTexture = game.getTextureFromAtlases(id + '_fs_blur')
    this._sprite.texture = mode ? this._staticFSTex : this._staticTex
    this._sprite.scale.set(this._scale)
    this.addChild(this._sprite)
  }

  swapSpine(visible){
    this._spine.setToSetupPose()
    this._spine.visible  = visible
    this._sprite.visible = !visible
  }

  playStatic(){
    this.swapSpine(false)
    const mode = this._fs
    this._sprite.filters = null
    this._sprite.tint = 0xFFFFFF
    this._sprite.texture = mode ? this._staticFSTex : this._staticTex
  }
  playMove(){
    this.swapSpine(false)
    const mode = this._fs

    if(this._blurTexture) {
      this._sprite.texture = mode ? this._blurFSTexture : this._blurTexture
    }
    this._sprite.tint = 0xFFFFFF
  }

  playSpineStop(){
    const mode = this._fs
    const anim = mode ? '-fs' : '-reg'
    if(this._spine.state.hasAnimation(`stop${anim}`)) {
      this.swapSpine(true)
      this._spine.playCallBack( `stop${anim}`, false, () => {
        this.swapSpine(false)
      })
    }
  }
  playDim(){
    this.swapSpine(false)
    tint(this._sprite, time).then()

  }
  playIdleAnimation(){
    this.swapSpine(true)
    const mode = this._fs
    const anim = mode ? '-fs' : '-reg'
    this._spine.playCallBack(`idle${anim}`, true)
  }

  playSpineFreeSpin(){
    this.swapSpine(true)
    if(this._spine.state.hasAnimation('bonus')){
      this._spine.playCallBack('bonus', false, () => {
        this.swapSpine(false)
        signal.dispatch('WIN-SCATTER-ANIM:DONE')
      })
    }
  }
  makeWinAnimation(totalWin){
    this.swapSpine(true)
    const mode = this._fs
    const anim = mode ? '-fs' : '-reg'
    if(this._spine.state.hasAnimation('total' + anim) && totalWin){
      this._spine.playCallBack(  'total' + anim, false, () => {
        this._spine.stop()
        this.swapSpine(false)
      })
    }
    else if(this._spine.state.hasAnimation('win' + anim)){
      this._spine.playCallBack(  'win' + anim, false, () => {
        this._spine.stop()
        this.swapSpine(false)
      })
    }
    else{
      this._spine.playCallBack( 'animation' + anim, false, () => {
        this._spine.stop()
        this.swapSpine(false)
      })
    }

  }

}
